import type { FacultyCourseLoad } from "@/lib/api/faculty";
import { courseStatusWord } from "@/components/people/teaching/course-status";
import { teachingCopy as copy, teachingText } from "@/components/people/visit/teaching-copy";

/** Directory evidence grants no course-entry authority. */
export function assignmentFacts(course: FacultyCourseLoad): string {
  return [course.semester_name || copy.noTerm, course.crn ? teachingText.crn(course.crn) : null,
    course.assignment_kind ? course.assignment_kind === "primary" ? copy.primary : copy.coInstructor : null,
    course.status && course.status !== "published" ? courseStatusWord(course.status) : null,
  ].filter(Boolean).join(" · ");
}
